<app-dialog-close-button class="close-button" (closed)="close()"></app-dialog-close-button>
<div vng-dialog-title class="text-center">
  <strong *ngIf="!paymenthMethodAttachedToActivePlan">Are you sure you want to remove payment method?</strong>
  <strong *ngIf="paymenthMethodAttachedToActivePlan">
    This card is associated with an active plan. Add a new payment method before removing selected card.
  </strong>
</div>

<div *ngIf="!paymenthMethodAttachedToActivePlan">
  <span style="display:flex; justify-content:center; align-items:center" class="mb-small">
    <ng-template *ngIf="paymentMethod.brand === 'visa'">
      <svg-icon-sprite width="28px" height="17px" src="icon-visa"> </svg-icon-sprite>
    </ng-template>
    <ng-template *ngIf="paymentMethod.brand === 'mastercard'">
      <svg-icon-sprite width="28px" height="17px" src="icon-mastercard"> </svg-icon-sprite>
    </ng-template>
    ****{{ paymentMethod.cardLastFour }}
  </span>
</div>

<vng-dialog-content>
  <vng-divider class="mb-2"></vng-divider>
</vng-dialog-content>

<vng-dialog-actions align="center" class="top-space mb-small" style="display:flex; justify-content:center; align-items:center; gap:15px">
  <button
    *ngIf="!paymenthMethodAttachedToActivePlan"
    (click)="removeMethod(paymentMethod)"
    [disabled]="disabled"
    vng-button
    variant="primary"
  >
    Remove Payment Method
  </button>
  <button *ngIf="paymenthMethodAttachedToActivePlan" (click)="addPaymentmethod()" vng-button variant="primary">
    Add Payment Method
  </button>
  <button (click)="close()" vng-button variant="secondary">Cancel</button>
</vng-dialog-actions>
